import { EnergyFlow } from '../../../../ui/Icon/BrandedIcons/Utilita/EnergyFlow';
import { Finance } from '../../../../ui/Icon/BrandedIcons/Utilita/Finance';
import { Help } from '../../../../ui/Icon/BrandedIcons/Utilita/Help';
import { Settings } from '../../../../ui/Icon/BrandedIcons/Utilita/Settings';
import { TariffRecommender } from '../../../../ui/Icon/BrandedIcons/Utilita/TariffRecommender';
import Today from '../../../../ui/Icon/BrandedIcons/Utilita/Today';
import type { NavbarStyles } from '../../ThemeTypes';
import colors from '../colors';
import fonts from '../fonts';

const navbar: NavbarStyles = {
  navbar: {
    padding: '1rem 1rem 0.5rem 1rem !important',
    '${min.sm}': {
      padding: '1rem calc(1rem + 15px) !important',
    },
    '${min.md}': {
      padding: '1.5rem calc(1rem + 15px) !important',
    },
    '.nav-link': {
      textDecoration: 'none',
      color: `${colors.headerText} !important`,
      fontWeight: fonts.fontWeights.bold,
      fontSize: '14px',
      '&.active, &:hover': {
        color: `${colors.primary}`,
      },
    },
    '.navbar-toggler .icon-bar': {
      background: `${colors.black} !important`,
    },
    '.onboarding-nav-container & .nav-link:hover': {
      color: `${colors.black}`,
      opacity: 0.6,
    },
    '.theme-logo': {
      flex: '1',
      'justify-content': 'center',
      display: 'flex',
      paddingLeft: '46px', // this is the width the burger menu takes up
      '${min.sm}': {
        flex: 'auto',
        'justify-content': 'center',
        display: 'block',
        paddingLeft: '0',
      },
      '${min.lg}': {
        display: 'block',
        paddingLeft: '0',
      },
    },
  },
  logoPath: '/images/utilita-logo.svg',
  headerBorder: '1px solid #CCCCCC',
  mainNavIcons: {
    today: Today,
    savings: Finance,
    energyFlow: EnergyFlow,
    tariffRecommender: TariffRecommender,
    turnDownAndSave: Today,
    settings: Settings,
    help: Help,
  },
  onboarding: {
    '${min.lg}': {
      borderBottom: 'none !important',
      background: 'transparent !important',
    },
    '.theme-logo': {
      '${min.lg}': {
        display: 'none',
      },
      '${min.md}': {
        display: 'none',
      },
      '${min.sm}': {
        display: 'none',
      },
    },
  },
  container: {
    '${min.md}': {
      justifyContent: 'flex-end',
    },
  },
};

export default navbar;
